import React, { useState } from 'react';
import QrReader from 'react-qr-scanner';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { API_BASE } from '../config';
import '../styles/QrScannerComponent.css';

const CartFreeScanner = () => {
  const navigate = useNavigate();
  const { token } = useAuth();
  const [lastScannedCode, setLastScannedCode] = useState(null);
  const [cartData, setCartData] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [scanKey, setScanKey] = useState(0);

  const handleScan = async (data) => {
    if (!data || data.text === lastScannedCode) return;

    const scannedCode = data.text.trim();
    setLastScannedCode(scannedCode);

    try {
      const response = await fetch(`${API_BASE}/free-cart/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`,
        },
        body: JSON.stringify({
          cart_code: scannedCode
        }),
      });

      if (response.ok) {
        setCartData({
          code: scannedCode,
          status: 'success'
        });
        setErrorMessage(null);
      } else {
        const result = await response.json();
        setErrorMessage(result.error || 'Error al liberar el carrito');
        setCartData(null);
      }
    } catch (error) {
      console.error('Error:', error);
      setErrorMessage('Error de conexión. Intenta de nuevo.');
      setCartData(null);
    }
  };

  const handleError = (err) => {
    console.error('Error al escanear:', err);
  };

  const handleRestartScan = () => {
    setLastScannedCode(null);
    setCartData(null);
    setErrorMessage(null);
    setScanKey((prevKey) => prevKey + 1);
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="qrscanner-container">
      <button onClick={handleBack} className="qrscanner-back-button">
        &#8592;
      </button>

      <h1 className="qrscanner-title">Liberar Carrito</h1>

      <div className="qrscanner-video-container">
        <QrReader
          key={scanKey}
          delay={500}
          onError={handleError}
          onScan={handleScan}
          style={{ width: '100%' }}
          constraints={{
            video: {
              facingMode: 'environment',
            },
          }}
        />
      </div>

      {errorMessage && <p className="error-message">{errorMessage}</p>}

      {cartData && (
        <div className="cart-info-container">
          <h2 className="cart-info-title">Carrito Liberado</h2>
          <div className="cart-info-details">
            <p><strong>Código:</strong> {cartData.code}</p>
          </div>
        </div>
      )}

      <div className="button-container">
        <button onClick={handleRestartScan} className="qrscanner-restart-button">
          Volver a escanear
        </button>
        <button onClick={handleBack} className="qrscanner-back-button" style={{ marginTop: '10px' }}>
          Volver
        </button>
      </div>
    </div>
  );
};

export default CartFreeScanner;
